import React from 'react';
import { array, bool, func, object, string } from 'prop-types';

import LoadingState from '../../../LoadingState';
import UpcomingAppointmentItem from './UpcomingAppointmentItem/UpcomingAppointmentItemContainer';

import s from './UpcomingAppointmentsContainer.css';


const UpcomingAppointmentsContainer = ({ ...props }) => {

  // Render UpcomingAppointmentItem when they are available, otherwise display a placeholder message.
  const getUpcomingAppointments = () => {
    const upcomingAppointments = props.upcomingAppointments;
    const noUpcomingAppointments = (props.upcomingAppointments.length === 0);

    const messagePlaceholder = (
      <p className={s.messagePlaceholder}>
        You have no Upcoming Appointments.
      </p>
    );

    const upcomingAppointmentItem = upcomingAppointments.map((appt) =>
      <UpcomingAppointmentItem
        appt={appt}
        authenticatedPreferences={props.authenticatedPreferences}
        confirm={props.confirm}
        cancel={props.cancel}
        closeAlertDialog={props.closeAlertDialog}
        closeConfirmDialog={props.closeConfirmDialog}
        email={props.email}
        defaultEmailRecipient={props.defaultEmailRecipient}
        hideFullPageLoadingState={props.hideFullPageLoadingState}
        key={appt.id}
        openConfirmDialog={props.openConfirmDialog}
        possibleMessageRecipients={props.possibleMessageRecipients}
        sendAppointmentMessage={props.sendAppointmentMessage}
        showFullPageLoadingState={props.showFullPageLoadingState}
      />
    );

    // No Upcoming Appointments, render placeholder, else render UpcomingAppointmentItem
    return (noUpcomingAppointments ? messagePlaceholder : upcomingAppointmentItem);
  };

  if (props.loadingState) {
    return (
      <section className={s.component} id="upcomingAppointmentsContainer__loading">
        <h3 className={s.header}>
          Upcoming Appointments
        </h3>
        <p className={s.messagePlaceholder}>
          Loading your Upcoming Appointments...
        </p>
        <LoadingState context="upcomingAppointments" />
      </section>
    );
  }

  return (
    <section className={s.component} id="upcomingAppointmentsContainer">
      <h3 className={s.header}>
        Upcoming Appointments
      </h3>
      {getUpcomingAppointments()}
    </section>
  );

};

UpcomingAppointmentsContainer.propTypes = {
  authenticatedPreferences: object,
  confirm: func,
  cancel: func,
  closeAlertDialog: func,
  closeConfirmDialog: func,
  defaultEmailRecipient: string,
  email: func,
  hideFullPageLoadingState: func,
  loadingState: bool,
  openConfirmDialog: func,
  possibleMessageRecipients: array,
  sendAppointmentMessage: func,
  showFullPageLoadingState: func,
  upcomingAppointments: array,
};

export default UpcomingAppointmentsContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/UpcomingAppointments/UpcomingAppointmentsContainer.js